import { c as _c } from "react/compiler-runtime";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import React from "react";
import { COOKIE_INVENTORY_ROW_IDS, type CookieInventoryRowId } from "#/features/privacy/constants/cookieInventory";
import type { TranslationFunctions } from "#/i18n/i18n-types";
type PrivacyCookieInventoryTableProps = {
  LL: TranslationFunctions;
};
type CookieRowLabels = {
  name: string;
  provider: string;
  purpose: string;
  duration: string;
  type: string;
};
const getCookieRowLabels = (LL: TranslationFunctions, rowId: CookieInventoryRowId): CookieRowLabels => {
  switch (rowId) {
    case "session":
      return {
        name: LL.PRIVACY_COOKIE_SESSION_NAME(),
        provider: LL.PRIVACY_COOKIE_SESSION_PROVIDER(),
        purpose: LL.PRIVACY_COOKIE_SESSION_PURPOSE(),
        duration: LL.PRIVACY_COOKIE_SESSION_DURATION(),
        type: LL.PRIVACY_COOKIE_SESSION_TYPE()
      };
    case "csrf":
      return {
        name: LL.PRIVACY_COOKIE_CSRF_NAME(),
        provider: LL.PRIVACY_COOKIE_CSRF_PROVIDER(),
        purpose: LL.PRIVACY_COOKIE_CSRF_PURPOSE(),
        duration: LL.PRIVACY_COOKIE_CSRF_DURATION(),
        type: LL.PRIVACY_COOKIE_CSRF_TYPE()
      };
    case "leetcode":
      return {
        name: LL.PRIVACY_COOKIE_LEETCODE_NAME(),
        provider: LL.PRIVACY_COOKIE_LEETCODE_PROVIDER(),
        purpose: LL.PRIVACY_COOKIE_LEETCODE_PURPOSE(),
        duration: LL.PRIVACY_COOKIE_LEETCODE_DURATION(),
        type: LL.PRIVACY_COOKIE_LEETCODE_TYPE()
      };
    case "consentRecord":
      return {
        name: LL.PRIVACY_COOKIE_CONSENT_RECORD_NAME(),
        provider: LL.PRIVACY_COOKIE_CONSENT_RECORD_PROVIDER(),
        purpose: LL.PRIVACY_COOKIE_CONSENT_RECORD_PURPOSE(),
        duration: LL.PRIVACY_COOKIE_CONSENT_RECORD_DURATION(),
        type: LL.PRIVACY_COOKIE_CONSENT_RECORD_TYPE()
      };
    case "locale":
      return {
        name: LL.PRIVACY_COOKIE_LOCALE_NAME(),
        provider: LL.PRIVACY_COOKIE_LOCALE_PROVIDER(),
        purpose: LL.PRIVACY_COOKIE_LOCALE_PURPOSE(),
        duration: LL.PRIVACY_COOKIE_LOCALE_DURATION(),
        type: LL.PRIVACY_COOKIE_LOCALE_TYPE()
      };
    case "playgroundPath":
      return {
        name: LL.PRIVACY_COOKIE_PLAYGROUND_PATH_NAME(),
        provider: LL.PRIVACY_COOKIE_PLAYGROUND_PATH_PROVIDER(),
        purpose: LL.PRIVACY_COOKIE_PLAYGROUND_PATH_PURPOSE(),
        duration: LL.PRIVACY_COOKIE_PLAYGROUND_PATH_DURATION(),
        type: LL.PRIVACY_COOKIE_PLAYGROUND_PATH_TYPE()
      };
    case "analytics":
      return {
        name: LL.PRIVACY_COOKIE_ANALYTICS_NAME(),
        provider: LL.PRIVACY_COOKIE_ANALYTICS_PROVIDER(),
        purpose: LL.PRIVACY_COOKIE_ANALYTICS_PURPOSE(),
        duration: LL.PRIVACY_COOKIE_ANALYTICS_DURATION(),
        type: LL.PRIVACY_COOKIE_ANALYTICS_TYPE()
      };
    case "materialIcons":
      return {
        name: LL.PRIVACY_COOKIE_MATERIAL_ICONS_NAME(),
        provider: LL.PRIVACY_COOKIE_MATERIAL_ICONS_PROVIDER(),
        purpose: LL.PRIVACY_COOKIE_MATERIAL_ICONS_PURPOSE(),
        duration: LL.PRIVACY_COOKIE_MATERIAL_ICONS_DURATION(),
        type: LL.PRIVACY_COOKIE_MATERIAL_ICONS_TYPE()
      };
  }
};
export const PrivacyCookieInventoryTable: React.FC<PrivacyCookieInventoryTableProps> = t0 => {
  const $ = _c(37);
  const {
    LL
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      mt: 2
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== LL) {
    t2 = LL.PRIVACY_COOKIE_TABLE_CAPTION();
    $[1] = LL;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== LL) {
    t3 = LL.PRIVACY_COOKIE_TABLE_COL_NAME();
    $[3] = LL;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <TableCell>{t3}</TableCell>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== LL) {
    t5 = LL.PRIVACY_COOKIE_TABLE_COL_PROVIDER();
    $[7] = LL;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <TableCell>{t5}</TableCell>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== LL) {
    t7 = LL.PRIVACY_COOKIE_TABLE_COL_PURPOSE();
    $[11] = LL;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <TableCell>{t7}</TableCell>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== LL) {
    t9 = LL.PRIVACY_COOKIE_TABLE_COL_DURATION();
    $[15] = LL;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t9) {
    t10 = <TableCell>{t9}</TableCell>;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== LL) {
    t11 = LL.PRIVACY_COOKIE_TABLE_COL_TYPE();
    $[19] = LL;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11) {
    t12 = <TableCell>{t11}</TableCell>;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t10 || $[24] !== t12 || $[25] !== t4 || $[26] !== t6 || $[27] !== t8) {
    t13 = <TableHead><TableRow>{t4}{t6}{t8}{t10}{t12}</TableRow></TableHead>;
    $[23] = t10;
    $[24] = t12;
    $[25] = t4;
    $[26] = t6;
    $[27] = t8;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== LL) {
    t14 = COOKIE_INVENTORY_ROW_IDS.map(rowId => {
      const row = getCookieRowLabels(LL, rowId);
      return <TableRow key={rowId}><TableCell component="th" scope="row"><Typography variant="body2" component="code">{row.name}</Typography></TableCell><TableCell>{row.provider}</TableCell><TableCell>{row.purpose}</TableCell><TableCell>{row.duration}</TableCell><TableCell>{row.type}</TableCell></TableRow>;
    });
    $[29] = LL;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t14) {
    t15 = <TableBody>{t14}</TableBody>;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t13 || $[34] !== t15 || $[35] !== t2) {
    t16 = <TableContainer component={Paper} variant="outlined" sx={t1}><Table size="small" aria-label={t2}>{t13}{t15}</Table></TableContainer>;
    $[33] = t13;
    $[34] = t15;
    $[35] = t2;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  return t16;
};